// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 338) return "static/chunks/338-f60e46c837c918c6.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","477":"8479bc39"}[chunkId] || chunkId) + "." + {"82":"c7e7ae4b7252706d","146":"1752ee6cef559fd2","340":"1c48af2103a82b40","367":"61e7cd59b52ed438","477":"d093cdfdcae3b83a","497":"830387ebd927b113","747":"7e7468ad6213d4c4"}[chunkId] + ".js";
};